<div class="min-h-screen bg-gradient-to-br">
  <!-- Use the shared navbar component -->
  <app-loader [isLoading]="loading"></app-loader>

  <!-- Main Content -->
  <br />
  <div class="container mx-auto px-4">
    <app-page-title titleKey="documents.title"></app-page-title>

    <!-- Use the shared children selector component -->
    <app-children-selector
      [autoSelectFirst]="true"
      (studentSelected)="onStudentSelected($event)"
      (studentsLoaded)="onStudentsLoaded($event)"
    >
    </app-children-selector>

    <!-- Documents Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      <!-- Loading State -->
      <div
        *ngIf="loading"
        class="col-span-full flex justify-center items-center py-12"
      >
        <div class="text-gray-500">{{ "documents.loading" | translate }}</div>
      </div>

      <!-- No Documents State -->
      <div
        *ngIf="!loading && documents.length === 0"
        class="col-span-full flex justify-center items-center py-12"
      >
        <div class="text-gray-500">
          {{ "documents.noDocumentsFound" | translate }}
          {{ selectedStudent?.nameStudent }}
        </div>
      </div>

      <!-- Document Cards -->
      <div
        *ngFor="let document of paginatedDocuments"
        class="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col cursor-pointer"
        (click)="openDocumentModal(document)"
      >
        <div class="flex items-center justify-center rounded-lg mb-4">
          <img class="w-20 h-22" src="../../../assets/icons/docum.png" />
        </div>

        <div class="flex justify-between items-center mt-auto">
          <div>
            <h3 class="font-semibold text-gray-800">{{ document.name }}</h3>

            <h5 class="text-gray-800">
              {{ document.creationDate | date : "dd-MM-yyyy" }}
            </h5>
          </div>

          <button class="hover:scale-110 transition-transform">
            <!-- <svg
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24.375 20.9048L24.375 7.5C24.375 6.46447 23.5355 5.625 22.5 5.625C21.4645 5.625 20.625 6.46447 20.625 7.5L20.625 20.9048L16.4641 15.7037C15.8172 14.8951 14.6373 14.764 13.8287 15.4109C13.0201 16.0578 12.889 17.2377 13.5359 18.0463L21.0359 27.4213C21.3917 27.8661 21.9304 28.125 22.5 28.125C23.0696 28.125 23.6083 27.8661 23.9641 27.4213L31.4641 18.0463C32.111 17.2377 31.9799 16.0578 31.1713 15.4109C30.3627 14.764 29.1828 14.8951 28.5359 15.7037L24.375 20.9048Z"
                fill="#49BBBD"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.1076 29.7639L13.7965 24.375H9.375C7.30393 24.375 5.625 26.0539 5.625 28.125V35.625C5.625 37.6961 7.30393 39.375 9.375 39.375H35.625C37.6961 39.375 39.375 37.6961 39.375 35.625V28.125C39.375 26.0539 37.6961 24.375 35.625 24.375H31.2035L26.8924 29.7639C25.8249 31.0982 24.2088 31.875 22.5 31.875C20.7912 31.875 19.1751 31.0982 18.1076 29.7639ZM31.875 30C30.8395 30 30 30.8395 30 31.875C30 32.9105 30.8395 33.75 31.875 33.75H31.8938C32.9293 33.75 33.7688 32.9105 33.7688 31.875C33.7688 30.8395 32.9293 30 31.8938 30H31.875Z"
                fill="#49BBBD"
              />
            </svg> -->

             <svg
                    width="35"
                    height="35"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M24.375 20.9048L24.375 7.5C24.375 6.46447 23.5355 5.625 22.5 5.625C21.4645 5.625 20.625 6.46447 20.625 7.5L20.625 20.9048L16.4641 15.7037C15.8172 14.8951 14.6373 14.764 13.8287 15.4109C13.0201 16.0578 12.889 17.2377 13.5359 18.0463L21.0359 27.4213C21.3917 27.8661 21.9304 28.125 22.5 28.125C23.0696 28.125 23.6083 27.8661 23.9641 27.4213L31.4641 18.0463C32.111 17.2377 31.9799 16.0578 31.1713 15.4109C30.3627 14.764 29.1828 14.8951 28.5359 15.7037L24.375 20.9048Z"
                      fill="#f5ba6e"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.1076 29.7639L13.7965 24.375H9.375C7.30393 24.375 5.625 26.0539 5.625 28.125V35.625C5.625 37.6961 7.30393 39.375 9.375 39.375H35.625C37.6961 39.375 39.375 37.6961 39.375 35.625V28.125C39.375 26.0539 37.6961 24.375 35.625 24.375H31.2035L26.8924 29.7639C25.8249 31.0982 24.2088 31.875 22.5 31.875C20.7912 31.875 19.1751 31.0982 18.1076 29.7639ZM31.875 30C30.8395 30 30 30.8395 30 31.875C30 32.9105 30.8395 33.75 31.875 33.75H31.8938C32.9293 33.75 33.7688 32.9105 33.7688 31.875C33.7688 30.8395 32.9293 30 31.8938 30H31.875Z"
                      fill="#f5ba6e"
                    />
                  </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Document Modal -->
    <div
      *ngIf="selectedDocument"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      (click)="closeDocumentModal()"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto"
        (click)="$event.stopPropagation()"
      >
        <!-- Header -->
        <div
          class="sticky top-0 bg-gradient-to-r from-[#9DC6DC] to-[#C0F4A2] p-6 rounded-t-2xl"
        >
          <div class="flex justify-between items-start">
            <div class="flex-1 pr-4">
              <h2 class="text-xl font-bold text-white mb-1">
                {{ selectedDocument.name }}
              </h2>
              <p class="text-white/80 text-sm">
                {{ selectedDocument.nbrDocuments }}
                {{ "documents.fileCount" | translate }}
              </p>
            </div>
            <button
              (click)="closeDocumentModal()"
              class="text-white hover:text-gray-200 transition-colors p-1"
            >
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6">
          <!-- Description -->
          <div class="mb-6" *ngIf="selectedDocument.description">
            <p class="text-gray-600 text-sm leading-relaxed">
              {{ selectedDocument.description }}
            </p>
          </div>

          <!-- Files Section -->
          <div class="space-y-4">
            <div class="flex items-center space-x-2">
              <svg
                class="w-5 h-5 text-[#49BBBD]"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                />
              </svg>
              <h3 class="font-semibold text-gray-800">
                {{ "documents.filesSection" | translate }}
              </h3>
            </div>

            <!-- No Files State -->
            <div
              *ngIf="selectedDocument.files.length === 0"
              class="text-center py-8"
            >
              <svg
                class="w-12 h-12 text-gray-300 mx-auto mb-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <p class="text-gray-500 text-sm">
                {{ "documents.noFiles" | translate }}
              </p>
            </div>

            <!-- Files List -->
            <div class="space-y-3">
              <div
                *ngFor="let file of selectedDocument.files; let i = index"
                class="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-gray-200 hover:shadow-md transition-all"
              >
                <div class="flex items-center space-x-3 flex-1 min-w-0">
                  <div class="flex-shrink-0">
                    <svg
                      class="w-6 h-6 text-[#49BBBD]"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                      />
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="text-sm font-medium text-gray-900 truncate">
                      Fichier {{ i + 1 }}
                    </p>
                    <p class="text-xs text-gray-500">
                      {{ "documents.pdfDocument" | translate }}
                    </p>
                  </div>
                </div>
                <button
                  (click)="downloadFile(file.path); $event.stopPropagation()"
                  title="{{ 'documents.download' | translate }}"
                  attr.aria-label="{{ 'documents.download' | translate }}"
                  class="flex-shrink-0 hover:scale-110 transition-transform ml-3"
                >
                        <svg
                    width="35"
                    height="35"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M24.375 20.9048L24.375 7.5C24.375 6.46447 23.5355 5.625 22.5 5.625C21.4645 5.625 20.625 6.46447 20.625 7.5L20.625 20.9048L16.4641 15.7037C15.8172 14.8951 14.6373 14.764 13.8287 15.4109C13.0201 16.0578 12.889 17.2377 13.5359 18.0463L21.0359 27.4213C21.3917 27.8661 21.9304 28.125 22.5 28.125C23.0696 28.125 23.6083 27.8661 23.9641 27.4213L31.4641 18.0463C32.111 17.2377 31.9799 16.0578 31.1713 15.4109C30.3627 14.764 29.1828 14.8951 28.5359 15.7037L24.375 20.9048Z"
                      fill="#49BBBD"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.1076 29.7639L13.7965 24.375H9.375C7.30393 24.375 5.625 26.0539 5.625 28.125V35.625C5.625 37.6961 7.30393 39.375 9.375 39.375H35.625C37.6961 39.375 39.375 37.6961 39.375 35.625V28.125C39.375 26.0539 37.6961 24.375 35.625 24.375H31.2035L26.8924 29.7639C25.8249 31.0982 24.2088 31.875 22.5 31.875C20.7912 31.875 19.1751 31.0982 18.1076 29.7639ZM31.875 30C30.8395 30 30 30.8395 30 31.875C30 32.9105 30.8395 33.75 31.875 33.75H31.8938C32.9293 33.75 33.7688 32.9105 33.7688 31.875C33.7688 30.8395 32.9293 30 31.8938 30H31.875Z"
                      fill="#49BBBD"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-simple">
      <button
        (click)="previousPage()"
        [disabled]="currentPage === 1"
        class="btn-prev"
      >
        {{ "kissati.previous" | translate }}
      </button>

      <button
        *ngFor="let page of pageNumbers"
        (click)="goToPage(page)"
        [class.font-bold]="currentPage === page"
        class="px-3 py-2 hover:bg-[#65cac3] rounded transition-colors duration-200"
        style="border: 1px solid #65cac3"
      >
        {{ page }}
      </button>

      <button
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        class="btn-next"
      >
        {{ "kissati.next" | translate }}
      </button>
    </div>
  </div>
</div>
